/**
 * Stable CSS class names for E2E — StorePickupPackage page (and its subviews:
 * CargoSelection, CargoAdmission tabs, CargoAdmissionLayout stepper,
 * CargoAdmissionTab, AgreementSummaryTab and ReportHistory).
 * Used by the test automation team as deterministic selectors.
 *
 * Containers use `store-pickup-package__<element>`; inputs and user-interactable
 * controls use `store-pickup-package-input--<name>`.
 */
export const SPP = {
    page: 'store-pickup-package-page',
    root: 'store-pickup-package',
    loading: 'store-pickup-package__loading',
    breadcrumb: 'store-pickup-package__breadcrumb',
    body: 'store-pickup-package__body',

    selection: 'store-pickup-package__selection',
    selectionInfoCard: 'store-pickup-package__selection-info-card',
    selectionInfoCardContent: 'store-pickup-package__selection-info-card-content',
    selectionInfoRow: 'store-pickup-package__selection-info-row',
    selectionInfoIcon: 'store-pickup-package__selection-info-icon',
    selectionInfoBody: 'store-pickup-package__selection-info-body',
    selectionInfoTitle: 'store-pickup-package__selection-info-title',
    selectionInfoList: 'store-pickup-package__selection-info-list',
    selectionInfoItem: 'store-pickup-package__selection-info-item',
    selectionInfoItemWaiting: 'store-pickup-package__selection-info-item--waiting',
    selectionInfoItemPackage: 'store-pickup-package__selection-info-item--package',
    selectionInfoItemDPackage: 'store-pickup-package__selection-info-item--d-package',
    selectionAvatar: 'store-pickup-package__selection-avatar',
    selectionNoSearchText: 'store-pickup-package__selection-no-search-text',
    selectionCargoAutocomplete: 'store-pickup-package__selection-cargo-autocomplete',
    inputCargoCompany: 'store-pickup-package-input--cargo-company',
    inputDPackageNumber: 'store-pickup-package-input--d-package-number',
    btnNewAdmission: 'store-pickup-package-input--button-new-admission',

    admission: 'store-pickup-package__admission',
    admissionTabs: 'store-pickup-package__admission-tabs',
    admissionTab: 'store-pickup-package__admission-tab',
    admissionTabAdmission: 'store-pickup-package__admission-tab--admission',
    admissionTabReportHistory: 'store-pickup-package__admission-tab--report-history',
    admissionTabBody: 'store-pickup-package__admission-tab-body',

    admissionLayout: 'store-pickup-package__admission-layout',
    admissionStepper: 'store-pickup-package__admission-stepper',
    admissionStep: 'store-pickup-package__admission-step',
    admissionStepLabel: 'store-pickup-package__admission-step-label',

    admissionInner: 'store-pickup-package__admission-inner',
    admissionBarcodeInput: 'store-pickup-package-input--barcode',
    admissionBarcodeSubmit: 'store-pickup-package-input--button-barcode-submit',
    admissionGrid: 'store-pickup-package__admission-grid',
    admissionTotalRow: 'store-pickup-package__admission-total-row',
    admissionTotalAmount: 'store-pickup-package__admission-total-amount',
    admissionScannedCounter: 'store-pickup-package__admission-scanned-counter',
    admissionActions: 'store-pickup-package__admission-actions',
    btnClear: 'store-pickup-package-input--button-clear',
    btnContinue: 'store-pickup-package-input--button-continue',

    cellDamagedCheckbox: 'store-pickup-package-input--cell-damaged-checkbox',
    cellPackageBarcode: 'store-pickup-package__cell-package-barcode',
    cellShipmentNumber: 'store-pickup-package__cell-shipment-number',
    cellShipmentNumberLink: 'store-pickup-package-input--cell-shipment-number-link',
    cellShippingCompany: 'store-pickup-package__cell-shipping-company',
    cellStoreName: 'store-pickup-package__cell-store-name',
    cellStoreCode: 'store-pickup-package__cell-store-code',
    cellIsDPackage: 'store-pickup-package__cell-is-d-package',
    cellIsDPackageOk: 'store-pickup-package__cell-is-d-package--ok',
    cellIsDPackageFail: 'store-pickup-package__cell-is-d-package--fail',
    cellDPackageNo: 'store-pickup-package__cell-d-package-no',
    cellIsMissing: 'store-pickup-package__cell-is-missing',
    cellCenter: 'store-pickup-package__cell--center',
    btnMarkMissing: 'store-pickup-package-input--button-mark-missing',
    cellScanTime: 'store-pickup-package__cell-scan-time',

    summary: 'store-pickup-package__summary',
    summarySection: 'store-pickup-package__summary-section',
    summarySectionReceived: 'store-pickup-package__summary-section--received',
    summarySectionMismatch: 'store-pickup-package__summary-section--mismatch',
    summarySectionMissing: 'store-pickup-package__summary-section--missing',
    summarySectionDamaged: 'store-pickup-package__summary-section--damaged',
    summarySectionTitle: 'store-pickup-package__summary-section-title',
    summarySectionGrid: 'store-pickup-package__summary-section-grid',
    summaryTotalRow: 'store-pickup-package__summary-total-row',
    summaryTotalAmount: 'store-pickup-package__summary-total-amount',
    summaryActions: 'store-pickup-package__summary-actions',
    btnUpdateList: 'store-pickup-package-input--button-update-list',
    btnConfirmAgreement: 'store-pickup-package-input--button-confirm-agreement',

    history: 'store-pickup-package__history',
    historyLoading: 'store-pickup-package__history-loading',
    historyFilters: 'store-pickup-package__history-filters',
    historyDateRangeBox: 'store-pickup-package__history-date-range-box',
    inputHistoryDateRange: 'store-pickup-package-input--history-date-range',
    inputHistoryShippingListNo: 'store-pickup-package-input--history-shipping-list-no',
    inputHistoryStoreCode: 'store-pickup-package-input--history-store-code',
    btnHistorySearch: 'store-pickup-package-input--button-history-search',
    btnHistoryClear: 'store-pickup-package-input--button-history-clear',
    historyGrid: 'store-pickup-package__history-grid',

    cellDfsNumber: 'store-pickup-package__cell-dfs-number',
    cellDfsNumberLink: 'store-pickup-package-input--cell-dfs-number-link',
    cellDocumentDate: 'store-pickup-package__cell-document-date',
    cellOperatorName: 'store-pickup-package__cell-operator-name',
    cellShippingListNo: 'store-pickup-package__cell-shipping-list-no',
    cellShippingListNoLink: 'store-pickup-package-input--cell-shipping-list-no-link',
} as const;

export const sppCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
